import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Navbar } from '../../components/Navbar'
import { Footer } from '../../components/Footer'
import { PageContainer } from '../../components/styled/PageContainer'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export const RoadHazardWarranty = () => {
  return (
    <Box>
      <Helmet>
        <title>Road Hazard Warranty Campaign</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box display='flex' justifyContent='center'>
          <img src={'/client-static/roadHazardWarranty/road-hazard-warranty-2.png'} width='100%' />
        </Box>
        <Box display='flex' justifyContent='center'>
          <img src={'/client-static/roadHazardWarranty/road-hazard-warranty-1.png'} width='100%' />
        </Box>
        <Box
          display='flex'
          m='auto'
          px={3}
          py={5}
          mt={4}
          flexDirection={'column'}
          maxWidth={1420}
          gap={5}
        >
          <Box>
            <Typography variant='h4' fontWeight={'bold'} mb={2} style={{ color: '#321151' }}>
              What Does Road Shield Tyre Warranty benefits:
            </Typography>
          </Box>
          <Box>
            <Typography variant='h5' fontWeight={'bold'} mb={2} style={{ color: '#321151' }}>
              6 months Road Hazard Warranty
            </Typography>
            1-to-1 exchange for irreparable road hazard damage.
          </Box>
          <Box>
            <Typography variant='h5' fontWeight={'bold'} mb={2} style={{ color: '#321151' }}>
              6 Years Warranty
            </Typography>
            <Box>Manufacturing warranty from date of purchase.</Box>
          </Box>

          <Box>
            <Divider></Divider>
          </Box>

          <Box>
            <Typography variant='h5' fontWeight={'bold'} mb={2} style={{ color: '#321151' }}>
              What Does Road Hazard Tire Warranty Covers:
            </Typography>
            <List>
              <ListItem> • Breaks or cuts from foreign object from the road</ListItem>
              <ListItem> • Gutter damage of the tyre</ListItem>
              <ListItem> • Damage from potholes or uneven roads</ListItem>
            </List>
          </Box>

          <Box>
            <Box mb={2}>
              When you purchase every 2pcs/ 4pcs of Nexen SU1 / RU1 from Nexen Centre or any
              participating dealers you may qualify for the Road Hazard Tire Warranty.
            </Box>
            <TableContainer component={Paper} variant='outlined' elevation={0}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: { md: 200 } }}>
                      <Typography variant='body2' fontWeight={'bold'}>
                        Tyre Details
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant='body2' fontWeight={'bold'}>
                        Criteria
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Target Pattern</TableCell>
                    <TableCell>N’Fera SU1 & N’Fera RU1</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Size</TableCell>
                    <TableCell>All size within the selected patterns</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Warranty Period</TableCell>
                    <TableCell>
                      Within 6 months AND Tyre Thread Depth more than 7mm or more.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Operation Period</TableCell>
                    <TableCell>*Start from 1st Dec 2024</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box mt={4} mb={10}>
            <Button
              variant='contained'
              color='primary'
              size='large'
              component={Link}
              to='rhwarranty'
              style={{ width: '100%' }}
            >
              Register
            </Button>
          </Box>
        </Box>
      </PageContainer>
      <Footer />
    </Box>
  )
}
